module.exports = __webpack_public_path__ + "img/r3.4401d6ca.jpg";